<template>
  <b-container class="d-flex aling-items-center">
    <b-row>
      <b-col class="p-4">
        <b-card class="align-self-center" id="organizacoes-card">
          <div class="d-flex flex-wrap justify-content-between align-items-center">
            <div class="title">
              <h4 class="text-primary font-weight-bold">Instituição</h4>
              <small class="sub-title">Selecione a clínica onde deseja receber atendimento</small>
            </div>
            <div class="search-container">
              <search-filter placeholder="Buscar clínica..." @input="search"></search-filter>
            </div>
          </div>

          <hr />

          <b-row>
            <b-col
              style="cursor: pointer"
              sm="12"
              md="6"
              lg="4"
              xl="*"
              class="mb-4"
              v-for="institution in institutions"
              :key="institution.id"
              :data-cy="`instituicao-${institution.id}`"
              @click="navigate(institution.id)"
            >
              <b-row
                class="bg-light border no-gutters"
                @mouseover="active = institution.id"
                :class="{ shadow: institution.id === active }"
                align-content="center"
                style="min-height:125px;"
              >
                <b-col cols="4" class="p-2">
                  <img
                    v-if="!loading"
                    class="img-fluid"
                    :src="institution.img"
                    @error="placeholder"
                    alt
                  />
                </b-col>
                <b-col cols="8" class="d-flex align-items-center">
                  {{ institution.nome }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="bg-white mt-auto">
            <b-col cols="12">
              <b-pagination-nav
                v-if="pages !== 0"
                align="center"
                :base-url="'?page='"
                :number-of-pages="pages"
                :link-gen="linkGen"
                use-router
              ></b-pagination-nav>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { axiosInstance as Axios } from "@/main";
import Vue from "vue";
import VueResizeText from "vue-resize-text";
import SearchFilter from "../components/filter.vue";

Vue.use(VueResizeText);

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export default {
  name: "institution",
  components: { SearchFilter },
  data() {
    return {
      loading: true,
      active: false,
      institutions: [],
      pageNumber: 1,
      pages: 0,
      searchTerm: ""
    };
  },
  async mounted() {
    this.searchTerm = this.$route.query.search;
    await this.$store.dispatch("set_search", this.searchTerm);

    await this.loadOrganizations();
  },
  watch: {
    $route() {
      this.loadOrganizations();
    }
  },
  methods: {
    linkGen(pageNum) {
      return {
        query: { page: pageNum, search: this.searchTerm }
      };
    },
    async loadOrganizations() {
      var searchTerm = this.$route.query.search;

      try {
        let response = await Axios.get(
          `${this.$serverHost}geral/organizacoes?size=9${
            this.$route.query.page ? "&page=" + this.$route.query.page : ""
          }${searchTerm ? "&nome=" + searchTerm.toLowerCase() : ""}`
        );
        this.pageNumber = response.data.currentPage;
        this.pages = response.data.totalPages;
        this.institutions = response.data.content;
      } catch (e) {
        console.log(e);
      }

      this.loadImages();
    },
    loadImages() {
      let institutions = this.institutions.map(it => {
        return Axios.get(`${this.$serverHost}configs/logo`, {
          headers: { "X-Organizacao-ID": it.id }
        }).then(response => {
          return { ...it, img: `data:image/png; base64, ${response.data}` };
        });
      });

      Promise.all(institutions).then(response => {
        this.institutions = response;
        this.loading = false;
      });
    },
    navigate(id) {
      this.$router.push({ name: "index", params: { organizationId: id } });
    },
    placeholder(e) {
      e.target.src = require("../assets/images/clinic.png");
    },
    search: debounce(function(e) {
      this.searchTerm = e;
      this.$router.replace({ query: { page: "1", search: e } });
    }, 500)
  }
};
</script>

<style>
.responsive {
  max-width: 100%;
}

.search-input-divider, .input-label, .search-container hr {
  display: none;
}

.sub-title {
  font-size: 1rem;
}

#organizacoes-card .card-body {
  width: 1088px;
}

.search-container #search {
  height: 50px;
  width: 350px;
  font-size: 1rem;
}
</style>
